import React from "react";
import { withStyles } from '@material-ui/styles';

import { withRouter } from 'react-router-dom';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withShowModal from '../../../../hocs/with_show_modal.js';
import withScrollHandler from "../../../../hocs/with_scroll_handler.js";
import { compose } from 'redux';

import pageStyles from "../../../styles/page_styles.js";
import { infoPageStyles } from "../../base_info_page.js";

import I18n from "../../../../base/i18n.js";

import BaseInfoPage from "../../base_info_page.js";
import Button from "../../../../base/buttons/button.js";

import { AdminCompanyModel } from "../../../../models/companies/admin/company_model.js";
import { AdminUserModel } from "../../../../models/users/admin/user_model.js";

import ShowCompanyUseCase from "../../../../use_cases/admin/companies/companies/show_company_use_case.js";
import SaveCompanyUseCase from "../../../../use_cases/admin/companies/companies/save_company_use_case.js";

import InfoPageHeader from "../../components/info_page_header.js";
import NavigationTabs from "../../components/navigation_tabs.js";

import CompanyInfoTabContent from "./components/company_info_tab_content.js";
import MembersInfoTabContent from "./components/members_info_tab_content.js";

import { InviteMemberType } from "../../../modals/constants.js";
import Routes from "../../../routes.js";

const styles = theme => ({
});

const InfoTab    = "info";
const MembersTab = "members";

class CompanyInfoPage extends BaseInfoPage {

  constructor(props) {
    super(props);

    this.tabs = [
      {
        identifier: InfoTab,
        label: I18n.t("admin.companies.company.tabs.info")
      },
      {
        identifier: MembersTab,
        label: I18n.t("admin.companies.company.tabs.members")
      }
    ]

    if(!this.state.currentTab) {
      this.state.currentTab = this.tabs[0].identifier;
    }
  }

  loadItem() {
    if(this.identifier) {
      this.processDataLoader(this.showUseCase.execute(this.identifier));
    }
    else {
      this.item.key = "newItem";
      this.setState({
        loading: false
      });
    }
  }

  defaultItem() {
    return {
      slug: this.identifier,
      key: "notLoadedItem"
    }
  }

  header() {
    const { currentTab } = this.state;
    return <React.Fragment>
      <InfoPageHeader title = { this.pageTitle() }>
        { this.headerContent() }
      </InfoPageHeader>
      {
        this.identifier &&
        <NavigationTabs tabs = { this.tabs }
                        currentTab = { currentTab }
                        onChangeTab = { this.onChangeTab } />
      }
    </React.Fragment>
  }

  headerContent() {
    const { submit, loading } = this.state;
    return <React.Fragment>
      {
        this.identifier && 
        <Button disabled = { submit || loading } 
                onClick = { this.inviteMember } >
          { I18n.t("admin.companies.company.action.invite_member") }
        </Button>
      }
    </React.Fragment>
  }

  inviteMember = () => {
    const { showModal } = this.props;
    showModal(InviteMemberType, {
      company: this.item,
      onSave: this.onMemberInvited
    })
  }

  onMemberInvited = (member) => {
    member.key = member.id;
    member.itemUrl = Routes.user(member.user);
    this.item.members.push(member);
    this.forceUpdate();
  }

  processLoadedItem(result) {
    const { data: { company } } = result;
    this.item = company;
    this.item.members = this.item.members.map((member) => {
      return {
        ...member,
        itemUrl: Routes.user(member.user),
        key: member.id
      }
    })
  }

  buttonsIsVisible() {
    const { currentTab } = this.state;
    return currentTab === InfoTab;
  }

  content() {
    const { errorData, currentTab, loading } = this.state;

    return <React.Fragment key = { this.item.key } >
      {
        !loading && <CompanyInfoTabContent company = { this.item } 
                                           errorData = { errorData }
                                           onItemChanged = { this.onItemChange }
                                           visible = { currentTab === InfoTab } />
      }
      {
        !loading && this.identifier && <MembersInfoTabContent company = { this.item } 
                                                              visible = { currentTab === MembersTab } />
      }
    </React.Fragment>
  }
}

CompanyInfoPage.defaultProps = {
  dataModel: AdminCompanyModel,
  showUseCase: ShowCompanyUseCase,
  saveUseCase: SaveCompanyUseCase,
  routeFunc: Routes.company
}

export default compose(
  withRouter,
  withShowToast,
  withShowModal,
  withCurrentUser,
  withScrollHandler,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(CompanyInfoPage);
